import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TabletTwoToneSvg from "@ant-design/icons-svg/es/asn/TabletTwoTone";
import AntdIcon from '../components/AntdIcon';
var TabletTwoTone = function TabletTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: TabletTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(TabletTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'TabletTwoTone';
}
export default RefIcon;